import { BatchDelete, BatchUploaded } from '@icons'
import cn from '@integrations/classnames'
import type { ReactNode } from '@integrations/react'
import { tr } from 'mmfintech-commons'
import { DragAndDrop, FileInput } from 'mmfintech-portal-commons'
import styles from './FileUploadPane.module.scss'
import UploadComponent from './UploadComponent'

interface Props {
  caption?: ReactNode
  acceptType?: string[]
  disabled?: boolean
  file: File
  onFileSelected: (files: any) => void
  onFileError: (errors: any) => void
  onFileRemove: () => void
}

function FileUploadPane({
  caption = 'Drag & Drop File',
  acceptType,
  disabled,
  file,
  onFileSelected,
  onFileError,
  onFileRemove
}: Props) {
  return disabled ? (
    <UploadComponent caption={caption} acceptType={acceptType} isDisabled={true} />
  ) : (
    <DragAndDrop onDrop={onFileSelected} onError={onFileError} acceptType={acceptType}>
      <FileInput maxNumber={1} acceptType={acceptType} onChange={onFileSelected} onError={onFileError}>
        {({ onFileUpload, onRemoveAll }) =>
          file ? (
            <div className={cn(styles['file-upload-wrapper'], 'file-upload-wrapper')}>
              <div className={cn(styles['file-upload-container'], 'file-upload-container')}>
                <BatchUploaded />
                <div className={cn(styles['uploaded-filename'], 'uploaded-filename')}>
                  <span className={cn(styles['label'], 'label')}>
                    {tr('FRONTEND.FILE_UPLOAD.UPLOADED_NAME', 'File uploaded')}
                  </span>
                  <span className={cn(styles['filename'], 'filename')}>{file.name}</span>
                </div>
              </div>
              <div
                className={cn(styles['uploaded-file-delete'], 'uploaded-file-delete')}
                data-test='delete-file-button'
                onClick={onFileRemove}
              >
                <BatchDelete />
              </div>
            </div>
          ) : (
            <UploadComponent
              caption={caption}
              acceptType={acceptType}
              onUpload={() => {
                onRemoveAll()
                onFileUpload()
              }}
            />
          )
        }
      </FileInput>
    </DragAndDrop>
  )
}

export default FileUploadPane
